<template>
    <div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>下单列表</b></p>

            <div style="display:inline-block">
                <el-radio-group v-model="statSearch" @input="searchByStatus">
                    <div class="el-badge">
                        <el-radio-button label="0">待审</el-radio-button>
                        <sup class="radio-sup" v-if="noTrialCount == 0 ? false : true">{{ noTrialCount }}</sup>
                    </div>

                    <div class="el-badge">
                        <el-radio-button label="1">已审</el-radio-button>
                        <sup class="radio-sup" v-if="reviewedCount == 0 ? false : true">{{ reviewedCount }}</sup>
                    </div>

                    <el-radio-button label="2">锁单</el-radio-button>
                    <el-radio-button label="3">拒单</el-radio-button>
                    <el-radio-button label="-1">全部</el-radio-button>
                </el-radio-group>
            </div>

            <div style="display:inline-block;width: 300px;">
                <el-input placeholder="请输入名称" v-model="queryValue" class="input-with-select">
                    <el-button slot="append" icon="el-icon-search" @click="searchOrder"></el-button>
                </el-input>
            </div>

            <p style="display:inline;float: right;line-height: 40px;margin:5px 0"
                v-if="customerCount == 1 ? false : customerCount == -1 ? false : true">
                <span>-</span>
                <el-button type="danger" round @click="refuseClick">拒接</el-button>
            </p>

            <p style="display:inline;float: right;line-height: 40px;margin:5px 0"
                v-if="customerCount == 1 ? false : customerCount == -1 ? false : true">
                <span>-</span>
                <el-button round @click="genClick">生成订单</el-button>
            </p>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;"
                v-if="customerCount == 1 ? false : customerCount == -1 ? false : true">
                <el-button type="info" icon="el-icon-download" circle @click="downloadClick"></el-button>
            </p>

            <p style="display:inline;float: right;line-height: 40px;margin:5px 0" v-if="customerCount == 1 ? true : false">
                <span>-</span>
                <el-button round @click="chkClick">审核</el-button>
            </p>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;"
                v-if="customerCount == 1 ? true : false">
                <el-button type="primary" round @click="openDialog">下单</el-button>
            </p>
        </div>

        <el-table :data="orderList" style="width: 100%" @select="selectClick" @row-click="rowClick" ref="placeTable"
            highlight-current-row>
            <el-table-column type="selection" width="45" label-class-name="DisabledSelection">
            </el-table-column>

            <el-table-column prop="customer" label="客户" min-width="9%">
            </el-table-column>

            <el-table-column prop="productName" label="产品名称" min-width="16%">
            </el-table-column>
            <el-table-column prop="orderCount" label="订单数量" min-width="8%" align="center">
            </el-table-column>
            <el-table-column prop="salesman" label="业务员" min-width="6%">
            </el-table-column>

            <el-table-column prop="createdTime" label="下单日期" min-width="9%">
            </el-table-column>
            <el-table-column prop="deliveryTime" label="交货日期" min-width="9%">
            </el-table-column>
            <el-table-column prop="statusStr" label="状态" min-width="5%">
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="15%">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="145">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="success" round size="small"
                        v-if="scope.row.statusStr == '待审' || scope.row.statusStr == '已审'">
                        {{ scope.row.statusStr == '待审' ? '更改' : '查看' }}
                    </el-button>
                    <el-button @click="deleteClick(scope.row)" type="danger" round size="small"
                        v-if="scope.row.statusStr == '待审' || scope.row.statusStr == '已审'">
                        删除
                    </el-button>
                    <el-button @click="placeClick(scope.row)" type="success" round size="small"
                        v-if="scope.row.statusStr == '拒单'">
                        再次下单
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount" layout="total, sizes, prev, pager, next"
                :total="total" @current-change="pageClick" :page-sizes="[6, 10, 14, 18]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

        <el-dialog title="下单详情" :visible.sync="dlgFormVisible" width="60%">
            <el-form :inline="true" :model="form" :rules="rules" ref="ruleForm">

                <div style="display: flex;">
                    <div style="width:48%;margin-left:40px">
                        <el-form-item label="产品名称" required :label-width="formLabelWidth" prop="productName">
                            <el-select v-model="form.productName" filterable remote reserve-keyword placeholder="请输入关键字"
                                :remote-method="searchProduct" :loading="loading" style="width:220px">
                                <el-option v-for="item in form.productList" :key="item.value" :label="item.productName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="订单数量" required :label-width="formLabelWidth">
                            <el-input-number v-model="form.orderCount" :step="1" :min="1"
                                style="width:220px"></el-input-number>
                        </el-form-item>
                    </div>

                    <el-form-item label="说明图片" :label-width="formLabelWidth" prop="imgUrl">
                        <el-upload class="avatar-uploader" action="#" :http-request="uploadImg" :show-file-list="false"
                            :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">

                            <img v-if="form.imgUrl" :src="'https://' + imagePath + form.imgUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>

                        </el-upload>
                    </el-form-item>
                </div>

                <el-form-item label="业务员" required :label-width="formLabelWidth" prop="salesman">
                    <el-select v-model="form.salesman" placeholder="请选择" style="width:220px">
                        <el-option v-for="item in form.empList" :key="item.value" :label="item.employeeName"
                            :value="item.userId">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="下单日期" required :label-width="formLabelWidth" prop="createdTime">
                    <el-date-picker v-model="form.createdTime" type="date" disabled>
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="交货日期" required :label-width="formLabelWidth" prop="deliveryTime">
                    <el-date-picker v-model="form.deliveryTime" type="date" placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <div style="width:350px;display: inline-block;"></div>

                <el-form-item label="备注" :label-width="formLabelWidth">
                    <el-input v-model="form.remark" autocomplete="off" type="textarea" style="width:570px"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dlgFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="$event => addPlaceOrder('ruleForm')">保 存</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    name: "PlaceOrder",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            userId: this.getUserId(),
            imagePath: this.getImagePath(),

            noTrialCount: 0,
            reviewedCount: 0,

            orderList: [],
            dlgFormVisible: false,

            statSearch: 0,

            queryValue: '',
            form: {
                id: '',

                imgUrl: '',
                imgFile: {},
                orderCount: 1,

                customerId: '',

                empList: [],
                salesman: '',
                salesmanId: '',
                productList: [],
                productId: '',
                productName: '',

                createdTime: new Date(),
                deliveryTime: '',
                status: 0,
                remark: '',
            },

            loading: false,
            formLabelWidth: '120px',

            pageIndex: 0,
            pageNum: 6,
            total: 0,
            pageCount: 0,

            customerCount: -1,

            rules: {
                salesman: [
                    { required: true, message: '请输入业务员', trigger: 'blur' },
                    { required: true, message: '请输入业务员', trigger: 'change' }
                ],
                productName: [
                    { required: true, message: '请输入产品名称', trigger: 'blur' },
                    { required: true, message: '请输入产品名称', trigger: 'change' }
                ],
                deliveryTime: [
                    { required: true, message: '请选择交货日期', trigger: 'blur' },
                    { required: true, message: '请选择交货日期', trigger: 'change' }
                ]
            }
        }
    },
    methods: {
        searchOrder(query) {
            this.orderList = []
            if (this.queryValue !== '') {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;

                    this.getAllOrder(this.statSearch)
                }, 200)
            } else {
                this.$message({
                    type: 'info',
                    message: '请输入搜索条件'
                })
            }
        },
        getBaseProductAll(val) {
            this.$axios({
                method: "post",
                url: "/shiro/base/product/getAll",
                data: {
                    queryParam: val,
                    status: 1,
                    pageIndex: -1,
                    pageNum: -1,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.form.productList = data.data
            })
        },
        uploadImg(f) {
            this.form.imgFile = f.file
        },
        searchProduct(val) {
            if (val !== '') {

                this.loading = true

                setTimeout(() => {
                    this.loading = false
                    this.getBaseProductAll(val)
                }, 200)

            } else {
                this.form.productList = []
            }
        },
        selectClick(selection, row) {

            this.$refs.placeTable.clearSelection()
            this.$refs.placeTable.toggleRowSelection(row)

            this.form.id = row.id
        },
        rowClick(row) {
            //console.log(row)
            this.$refs.placeTable.clearSelection()
            this.$refs.placeTable.toggleRowSelection(row)

            this.form.id = row.id
        },
        handleClick(row) {

            // console.log(row);
            this.form.id = row.id

            this.form.orderCount = row.orderCount
            this.form.imgUrl = row.imgUrl

            this.getEmpAll()

            this.form.salesman = row.salesmanId

            this.form.productName = row.productId

            this.form.createdTime = new Date(row.createdTime)
            this.form.deliveryTime = new Date(row.deliveryTime)
            this.form.status = row.status
            this.form.remark = row.remark

            this.dlgFormVisible = true
        },
        openDialog() {

            this.form.empList = []

            this.form.id = ''
            this.form.orderCount = 1

            this.form.salesman = ''
            this.form.productName = ''

            this.form.createdTime = new Date()
            this.form.deliveryTime = ''
            this.form.status = 0
            this.form.remark = ''

            this.form.imgUrl = ''

            this.dlgFormVisible = true

            this.getEmpAll()
        },

        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.removePlaceOrder(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        placeClick(row) {
            this.$confirm('确定要重新下单吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.rePlaceOrder(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        rePlaceOrder(row) {
            this.$axios({
                method: "post",
                url: "/shiro/place/order/again",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                this.$message({
                    type: 'success',
                    message: data.msg
                })

                this.getAllOrder(this.statSearch)
            })
        },
        chkClick() {

            if (this.form.id == '') {
                this.$message({
                    type: 'info',
                    message: '请先选择一条记录'
                })
                return
            }

            this.$confirm('确定审核吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.checkPlaceOrder()

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                })
            })
        },
        checkPlaceOrder() {
            this.$axios({
                method: "post",
                url: "/shiro/place/order/check",
                data: {
                    id: this.form.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.$message({
                    type: 'info',
                    message: data.msg
                })

                this.searchByStatus(this.statSearch)
            })
        },
        downloadClick() {
            this.$axios({
                method: "post",
                url: "/shiro/place/order/excel",
                data: {
                    status: this.statSearch,
                    maker: this.userId,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                },
                responseType: 'arraybuffer'
            }).then(result => {

                const data = result.data

                let objectUrl = result.config.url
                const blob = new Blob([data], {
                    type: 'application/vnd.ms-excel;charset=utf-8'
                })

                objectUrl = URL.createObjectURL(blob)
                const a = document.createElement("a")
                a.href = objectUrl

                a.download = "客户下单记录.xlsx"
                a.click()
                a.remove()
                URL.revokeObjectURL(objectUrl)
            })
        },
        genClick() {

            if (this.form.id == '') {
                this.$message({
                    type: 'info',
                    message: '请先选择一条记录'
                })
                return
            }

            this.$confirm('确定生成订单吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.genOrder()

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                })
            })
        },
        genOrder() {
            this.$axios({
                method: "post",
                url: "/shiro/place/order/gen",
                data: {
                    id: this.form.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.$message({
                    type: 'info',
                    message: data.msg
                })

                this.searchByStatus(this.statSearch)
            })
        },
        refuseClick() {

            if (this.form.id == '') {
                this.$message({
                    type: 'info',
                    message: '请先选择一条记录'
                })
                return
            }

            this.$confirm('确定拒接订单吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.refuseOrder()

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                })
            })
        },
        refuseOrder() {
            this.$axios({
                method: "post",
                url: "/shiro/place/order/refuse",
                data: {
                    id: this.form.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.$message({
                    type: 'info',
                    message: data.msg
                })

                this.searchByStatus(this.statSearch)
            })
        },
        getEmpAll() {
            if (this.form.customerId == '') {

                this.$notify({
                    title: '提示',
                    message: '由于客户归属原因，您无法进行下单操作',
                    duration: 0
                })
                return
            }

            this.$axios({
                method: "post",
                url: "/shiro/employee/get/customerId",
                data: {
                    customerId: this.form.customerId,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.form.empList = data.data
            })
        },
        addPlaceOrder(formName) {

            this.$refs[formName].validate((valid) => {
                if (valid) {

                    const form = new FormData()

                    form.append('id', this.form.id)
                    form.append('orderCount', this.form.orderCount)

                    form.append('salesman', this.form.salesman)
                    form.append('productName', this.form.productName)
                    form.append('createdTime', this.form.createdTime)
                    form.append('deliveryTime', this.form.deliveryTime)
                    form.append('status', this.form.status)
                    form.append('remark', this.form.remark)
                    form.append('companyId', this.companyId)
                    form.append('maker', this.userId)

                    // console.log('this.form.imgFile')
                    // console.log(this.form.imgFile)

                    let arr = Object.keys(this.form.imgFile)
                    if (arr.length == 0) {
                        // console.log('000')
                        form.append('imgFile', new File([], 'file'))
                    } else {
                        form.append('imgFile', this.form.imgFile)
                    }

                    this.$axios({
                        method: "post",
                        url: "/shiro/place/order/add",
                        data: form,
                        headers: {
                            token: this.token
                        }
                    }).then(result => {

                        const data = result.data

                        if (data.status != 200) {
                            this.$message(data.msg)
                            return
                        }

                        this.dlgFormVisible = false
                        this.getAllOrder(this.statSearch)
                    })
                } else {
                    return false
                }
            })
        },
        searchByStatus(val) {
            this.total=0
            
            this.getAllOrder(val)
        },
        removePlaceOrder(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/place/order/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                this.$message({
                    type: 'success',
                    message: data.msg
                })

                this.getAllOrder(this.statSearch)
            })
        },
        getAllOrder(val) {

            this.$axios({
                method: "post",
                url: "/shiro/place/order/getAll",
                data: {
                    status: val,
                    queryParam: this.queryValue,
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    maker: this.userId,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.orderList = data.data
                if (this.orderList.length > 0) {
                    this.total = this.orderList[0].total
                }

                for (let i in this.orderList) {
                    this.orderList[i].createdTime = this.$moment(this.orderList[i].createdTime).format("YYYY-MM-DD")
                    this.orderList[i].deliveryTime = this.$moment(this.orderList[i].deliveryTime).format("YYYY-MM-DD")

                    if (this.orderList[i].status == 0) {
                        this.orderList[i].statusStr = '待审'
                        
                    } else if (this.orderList[i].status == 1) {
                        this.orderList[i].statusStr = '已审'

                    } else if (this.orderList[i].status == 2) {
                        this.orderList[i].statusStr = '锁单'
                    } else {
                        this.orderList[i].statusStr = '拒单'
                    }
                }

                this.noTrialCount = 0
                this.reviewedCount = 0
                this.getOrderCount(0)
                //查询已审数
                this.getOrderCount(1)
            })
        },
        getOrderCount(val) {
            this.$axios({
                method: "post",
                url: "/shiro/place/order/getAll",
                data: {
                    status: val,
                    queryParam: this.queryValue,
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    maker: this.userId,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data.data

                for (let i in data) {

                    if (data[i].status == 0) {
                        this.noTrialCount = data[0].total
                    } else if (data[i].status == 1) {
                        this.reviewedCount = data[0].total
                    }
                }
            })
        },
        getCusByUser() {
            this.$axios({
                method: "post",
                url: "/shiro/base/customer/get/userId",
                data: {
                    companyId: this.companyId,
                    maker: this.userId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data.data

                var cusIdList = data

                this.customerCount = cusIdList.length

                if (this.customerCount == 1) {
                    this.form.customerId = cusIdList[0]
                }

            })
        },
        pageClick(currentPage) {
            this.orderList = []

            this.pageIndex = (currentPage - 1) * this.pageNum
            this.getAllOrder(this.statSearch)
        },
        handleSizeChange(val) {
            this.pageNum = val

            this.getAllOrder(this.statSearch)
        },
    },
    mounted() {
        console.log('PlaceOrder.vue--mounted()')
        this.setDefaultPath('/placeOrder')

        this.getAllOrder(this.statSearch)

        this.getCusByUser()

        this.getBaseProductAll('')
    }
}
</script>

<style>
.el-badge {
    position: relative;
    vertical-align: middle;
    display: inline-block;
}

.radio-sup {
    border-radius: 8px;
    color: #fff;
    display: inline-block;
    font-size: 13px;
    height: 18px;
    line-height: 18px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
    background-color: red;
    position: absolute;
    top: -10px;
    right: 60%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 118px;
    height: 118px;
    line-height: 118px;
    text-align: center;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}

.el-pagination__total {
    color: green;
}
</style>